import React from 'react';
import styled from 'styled-components/macro';
import { Link } from 'react-router-dom';
import { Row, Col, Div } from '../grid';
import { Paragraph, LinkButton } from '../typography';
import { Image } from '../Image';
import { ScreenSizeDetector } from '../../lib/helpers';

const DivWrap = styled(Div)`
  border: 1px solid ${({ theme }) => theme.colors.colorGreyLightAlt};
  background: #fff;
`;
const ImageWrap = styled(Div)`
  padding: 10px;
`;

export default ({
  title,
  image1,
  image1Size,
  image2,
  image2Size,
  link,
  paragraph,
}) => (
  <Col xs={6} sm={6} md={6} lg={6} xl={4} xxl={4} padding="0 7.5px" marginBottom="15px">
    <DivWrap h100p>
      <Col xs={12} h100p padding="0 10px">
        <Row h100p>
          <Col xs={12} md={4} textCenter>
            <Link to={link} title={title}>
              {!image2 && (
                <ScreenSizeDetector
                  imageHeight={[[575, image1Size[5]], [767, image1Size[4]], [991, image1Size[3]], [1199, image1Size[2]], [1599, image1Size[1]], image1Size[0]]}
                  height={[[575, image1Size[5]], [767, image1Size[4]], [991, image1Size[3]], [1199, image1Size[2]], [1599, image1Size[1]], image1Size[0]]}
                >
                  <Image name={image1} />
                </ScreenSizeDetector>
              )}
              {image2 && (
                <React.Fragment>
                  <Row h100p>
                    <Col xs={12} relative h100p padding="0">
                      <ImageWrap>
                        <ScreenSizeDetector
                          imageHeight={[[575, image1Size[5]], [767, image1Size[4]], [991, image1Size[3]], [1199, image1Size[2]], [1599, image1Size[1]], image1Size[0]]}
                          height={[[575, image1Size[5]], [767, image1Size[4]], [991, image1Size[3]], [1199, image1Size[2]], [1599, image1Size[1]], image1Size[0]]}
                        >
                          <Image name={image1} marginRight="5px" />
                        </ScreenSizeDetector>
                        <ScreenSizeDetector
                          imageHeight={[[575, image2Size[5]], [767, image2Size[4]], [991, image2Size[3]], [1199, image2Size[2]], [1599, image2Size[1]], image2Size[0]]}
                          height={[[575, image2Size[5]], [767, image2Size[4]], [991, image2Size[3]], [1199, image2Size[2]], [1599, image2Size[1]], image2Size[0]]}
                        >
                          <Image name={image2} marginLeft="5px" />
                        </ScreenSizeDetector>
                      </ImageWrap>
                    </Col>
                  </Row>
                </React.Fragment>
              )}
            </Link>
          </Col>
          <ScreenSizeDetector textCenter={[[575, true], false]} paddingTop={[[575, '0px'], '15px']}>
            <Col xs={12} md={8}>
              <ScreenSizeDetector fontSize={[[991, '18px'], '20px']} hide={[[575, true], false]}>
                <Paragraph fontWeight="bold" margin="0 0 10px 0">
                  {title}
                </Paragraph>
              </ScreenSizeDetector>
              <ScreenSizeDetector hide={[[575, true], false]}>
                <Div>
                  {paragraph}
                </Div>
              </ScreenSizeDetector>
              <LinkButton small to={link} title={title} arrow>
                {title}
              </LinkButton>
            </Col>
          </ScreenSizeDetector>
        </Row>
      </Col>
    </DivWrap>
  </Col>
);
